unit View.Operadoras_Cartao.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewOperadoras_CartaoEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbconta_id: TLabel;
    edconta_id: TDBEdit;
    lbcnpj: TLabel;
    edcnpj: TDBEdit;
    lbendereco: TLabel;
    edendereco: TDBEdit;
    lbnumero: TLabel;
    ednumero: TDBEdit;
    lbbairro: TLabel;
    edbairro: TDBEdit;
    lbcep: TLabel;
    edcep: TDBEdit;
    lbcidade_id: TLabel;
    edcidade_id: TDBEdit;
    lbtaxa_administracao: TLabel;
    edtaxa_administracao: TDBEdit;
    lbsigla: TLabel;
    edsigla: TDBEdit;
    lbcodigo_instituicao: TLabel;
    edcodigo_instituicao: TDBEdit;
    lbenviar_pdv: TLabel;
    edenviar_pdv: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientOperadoras_CartaoGet: TXDataWebClient;
    XDataClientOperadoras_CartaoDelete: TXDataWebClient;
    Operadoras_CartaoDataset: TXDataWebDataSet;
    Operadoras_CartaoDatasetid: TIntegerField;
    Operadoras_CartaoDatasetaliado_id: TIntegerField;
    Operadoras_CartaoDatasetdata_base_id: TIntegerField;
    Operadoras_CartaoDatasetnome: TStringField;
    Operadoras_CartaoDatasetconta_id: TIntegerField;
    Operadoras_CartaoDatasetcnpj: TStringField;
    Operadoras_CartaoDatasetendereco: TStringField;
    Operadoras_CartaoDatasetnumero: TIntegerField;
    Operadoras_CartaoDatasetbairro: TStringField;
    Operadoras_CartaoDatasetcep: TStringField;
    Operadoras_CartaoDatasetcidade_id: TIntegerField;
    Operadoras_CartaoDatasettaxa_administracao: TFloatField;
    Operadoras_CartaoDatasetsigla: TStringField;
    Operadoras_CartaoDatasetcodigo_instituicao: TStringField;
    Operadoras_CartaoDatasetenviar_pdv: TBooleanField;
    Operadoras_CartaoDatasetcodigo_interno: TIntegerField;
    Operadoras_CartaoDatasetexcluido: TBooleanField;
    Operadoras_CartaoDatasetinclusao: TDateTimeField;
    Operadoras_CartaoDatasetalteracao: TDateTimeField;
    Operadoras_CartaoDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientOperadoras_CartaoGetLoad(Response: TXDataClientResponse);
    procedure XDataClientOperadoras_CartaoDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientOperadoras_CartaoDeleteError(Error: TXDataClientError);
    procedure Operadoras_CartaoDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewOperadoras_CartaoEdit: TFViewOperadoras_CartaoEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewOperadoras_CartaoEdit }

procedure TFViewOperadoras_CartaoEdit.btSaveClick(Sender: TObject);
begin
  if Operadoras_CartaoDataset.State in dsEditModes then
  begin
        Operadoras_CartaoDataset.Post;
    Operadoras_CartaoDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewOperadoras_CartaoEdit.btDeleteClick(Sender: TObject);
begin
  if Operadoras_CartaoDataset.State in dsEditModes then
    Operadoras_CartaoDataset.Post;
  XDataClientOperadoras_CartaoDelete.Delete(Operadoras_CartaoDataset.EntitySetName,
    TJSObject(Operadoras_CartaoDataset.CurrentData));
end;


class function TFViewOperadoras_CartaoEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewOperadoras_CartaoEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewOperadoras_CartaoEdit.InsertEntity;
begin
  Operadoras_CartaoDataset.Close;
  Operadoras_CartaoDataset.SetJsonData('{}');
  Operadoras_CartaoDataset.Open;
  Operadoras_CartaoDataset.Insert;
end;

class function TFViewOperadoras_CartaoEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewOperadoras_CartaoEdit(AForm).FInserting := AInserting;
    TFViewOperadoras_CartaoEdit(AForm).FId := AId;
    TFViewOperadoras_CartaoEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewOperadoras_CartaoEdit(AForm).InsertEntity
    else
      TFViewOperadoras_CartaoEdit(AForm).LoadEntity;
    TFViewOperadoras_CartaoEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewOperadoras_CartaoEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewOperadoras_CartaoEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Operadoras_CartaoDataset.Connection.Model.DefaultSchema.FindEntityType(
      Operadoras_CartaoDataset.EntitySetName
    )
  );
  XDataClientOperadoras_CartaoGet.Get(Operadoras_CartaoDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewOperadoras_CartaoEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewOperadoras_CartaoEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewOperadoras_CartaoEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewOperadoras_CartaoEdit.XDataClientOperadoras_CartaoGetLoad(Response: TXDataClientResponse);
begin
  Operadoras_CartaoDataset.Close;
  Operadoras_CartaoDataset.SetJsonData(Response.Result);
  Operadoras_CartaoDataset.Open;
  
  Operadoras_CartaoDataset.Edit;  
end;

procedure TFViewOperadoras_CartaoEdit.XDataClientOperadoras_CartaoDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewOperadoras_CartaoEdit.XDataClientOperadoras_CartaoDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewOperadoras_CartaoEdit.Operadoras_CartaoDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewOperadoras_CartaoEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewOperadoras_CartaoEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.operadoras_cartao.form.lbid');
  lbaliado_id := TLabel.Create('view.operadoras_cartao.form.lbaliado_id');
  lbdata_base_id := TLabel.Create('view.operadoras_cartao.form.lbdata_base_id');
  lbnome := TLabel.Create('view.operadoras_cartao.form.lbnome');
  lbconta_id := TLabel.Create('view.operadoras_cartao.form.lbconta_id');
  lbcnpj := TLabel.Create('view.operadoras_cartao.form.lbcnpj');
  lbendereco := TLabel.Create('view.operadoras_cartao.form.lbendereco');
  lbnumero := TLabel.Create('view.operadoras_cartao.form.lbnumero');
  lbbairro := TLabel.Create('view.operadoras_cartao.form.lbbairro');
  lbcep := TLabel.Create('view.operadoras_cartao.form.lbcep');
  lbcidade_id := TLabel.Create('view.operadoras_cartao.form.lbcidade_id');
  lbtaxa_administracao := TLabel.Create('view.operadoras_cartao.form.lbtaxa_administracao');
  lbsigla := TLabel.Create('view.operadoras_cartao.form.lbsigla');
  lbcodigo_instituicao := TLabel.Create('view.operadoras_cartao.form.lbcodigo_instituicao');
  lbenviar_pdv := TLabel.Create('view.operadoras_cartao.form.lbenviar_pdv');
  lbcodigo_interno := TLabel.Create('view.operadoras_cartao.form.lbcodigo_interno');
  lbexcluido := TLabel.Create('view.operadoras_cartao.form.lbexcluido');
  lbinclusao := TLabel.Create('view.operadoras_cartao.form.lbinclusao');
  lbalteracao := TLabel.Create('view.operadoras_cartao.form.lbalteracao');
  lbexclusao := TLabel.Create('view.operadoras_cartao.form.lbexclusao');
  pnlMessage := TPanel.Create('view.operadoras_cartao.form.message');
  lbMessage := TLabel.Create('view.operadoras_cartao.form.message.label');
  btCloseMessage := TButton.Create('view.operadoras_cartao.form.message.button');
  btCancel := TButton.Create('view.operadoras_cartao.form.btBack');
  btSave := TButton.Create('view.operadoras_cartao.form.btSave');
  btDelete := TButton.Create('view.operadoras_cartao.form.btDelete');
  edid := TDBEdit.Create('view.operadoras_cartao.form.edid');
  edaliado_id := TDBEdit.Create('view.operadoras_cartao.form.edaliado_id');
  eddata_base_id := TDBEdit.Create('view.operadoras_cartao.form.eddata_base_id');
  ednome := TDBEdit.Create('view.operadoras_cartao.form.ednome');
  edconta_id := TDBEdit.Create('view.operadoras_cartao.form.edconta_id');
  edcnpj := TDBEdit.Create('view.operadoras_cartao.form.edcnpj');
  edendereco := TDBEdit.Create('view.operadoras_cartao.form.edendereco');
  ednumero := TDBEdit.Create('view.operadoras_cartao.form.ednumero');
  edbairro := TDBEdit.Create('view.operadoras_cartao.form.edbairro');
  edcep := TDBEdit.Create('view.operadoras_cartao.form.edcep');
  edcidade_id := TDBEdit.Create('view.operadoras_cartao.form.edcidade_id');
  edtaxa_administracao := TDBEdit.Create('view.operadoras_cartao.form.edtaxa_administracao');
  edsigla := TDBEdit.Create('view.operadoras_cartao.form.edsigla');
  edcodigo_instituicao := TDBEdit.Create('view.operadoras_cartao.form.edcodigo_instituicao');
  edenviar_pdv := TDBEdit.Create('view.operadoras_cartao.form.edenviar_pdv');
  edcodigo_interno := TDBEdit.Create('view.operadoras_cartao.form.edcodigo_interno');
  edexcluido := TDBEdit.Create('view.operadoras_cartao.form.edexcluido');
  edinclusao := TDBEdit.Create('view.operadoras_cartao.form.edinclusao');
  edalteracao := TDBEdit.Create('view.operadoras_cartao.form.edalteracao');
  edexclusao := TDBEdit.Create('view.operadoras_cartao.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Operadoras_CartaoDataset := TXDataWebDataSet.Create(Self);
  Operadoras_CartaoDatasetid := TIntegerField.Create(Self);
  Operadoras_CartaoDatasetaliado_id := TIntegerField.Create(Self);
  Operadoras_CartaoDatasetdata_base_id := TIntegerField.Create(Self);
  Operadoras_CartaoDatasetnome := TStringField.Create(Self);
  Operadoras_CartaoDatasetconta_id := TIntegerField.Create(Self);
  Operadoras_CartaoDatasetcnpj := TStringField.Create(Self);
  Operadoras_CartaoDatasetendereco := TStringField.Create(Self);
  Operadoras_CartaoDatasetnumero := TIntegerField.Create(Self);
  Operadoras_CartaoDatasetbairro := TStringField.Create(Self);
  Operadoras_CartaoDatasetcep := TStringField.Create(Self);
  Operadoras_CartaoDatasetcidade_id := TIntegerField.Create(Self);
  Operadoras_CartaoDatasettaxa_administracao := TFloatField.Create(Self);
  Operadoras_CartaoDatasetsigla := TStringField.Create(Self);
  Operadoras_CartaoDatasetcodigo_instituicao := TStringField.Create(Self);
  Operadoras_CartaoDatasetenviar_pdv := TBooleanField.Create(Self);
  Operadoras_CartaoDatasetcodigo_interno := TIntegerField.Create(Self);
  Operadoras_CartaoDatasetexcluido := TBooleanField.Create(Self);
  Operadoras_CartaoDatasetinclusao := TDateTimeField.Create(Self);
  Operadoras_CartaoDatasetalteracao := TDateTimeField.Create(Self);
  Operadoras_CartaoDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientOperadoras_CartaoGet := TXDataWebClient.Create(Self);
  XDataClientOperadoras_CartaoDelete := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbconta_id.BeforeLoadDFMValues;
  lbcnpj.BeforeLoadDFMValues;
  lbendereco.BeforeLoadDFMValues;
  lbnumero.BeforeLoadDFMValues;
  lbbairro.BeforeLoadDFMValues;
  lbcep.BeforeLoadDFMValues;
  lbcidade_id.BeforeLoadDFMValues;
  lbtaxa_administracao.BeforeLoadDFMValues;
  lbsigla.BeforeLoadDFMValues;
  lbcodigo_instituicao.BeforeLoadDFMValues;
  lbenviar_pdv.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  edconta_id.BeforeLoadDFMValues;
  edcnpj.BeforeLoadDFMValues;
  edendereco.BeforeLoadDFMValues;
  ednumero.BeforeLoadDFMValues;
  edbairro.BeforeLoadDFMValues;
  edcep.BeforeLoadDFMValues;
  edcidade_id.BeforeLoadDFMValues;
  edtaxa_administracao.BeforeLoadDFMValues;
  edsigla.BeforeLoadDFMValues;
  edcodigo_instituicao.BeforeLoadDFMValues;
  edenviar_pdv.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Operadoras_CartaoDataset.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetid.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetaliado_id.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetdata_base_id.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetnome.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetconta_id.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetcnpj.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetendereco.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetnumero.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetbairro.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetcep.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetcidade_id.BeforeLoadDFMValues;
  Operadoras_CartaoDatasettaxa_administracao.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetsigla.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetcodigo_instituicao.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetenviar_pdv.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetcodigo_interno.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetexcluido.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetinclusao.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetalteracao.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetexclusao.BeforeLoadDFMValues;
  XDataClientOperadoras_CartaoGet.BeforeLoadDFMValues;
  XDataClientOperadoras_CartaoDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewOperadoras_CartaoEdit';
    Width := 593;
    Height := 805;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 12;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 46;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.HeightPercent := 100.000000000000000000;
    lbaliado_id.WidthPercent := 100.000000000000000000;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 69;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.HeightPercent := 100.000000000000000000;
    lbdata_base_id.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 273;
    lbnome.Width := 30;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbconta_id.SetParentComponent(Self);
    lbconta_id.Name := 'lbconta_id';
    lbconta_id.Left := 24;
    lbconta_id.Top := 300;
    lbconta_id.Width := 45;
    lbconta_id.Height := 13;
    lbconta_id.Caption := 'conta_id:';
    lbconta_id.HeightPercent := 100.000000000000000000;
    lbconta_id.WidthPercent := 100.000000000000000000;
    lbcnpj.SetParentComponent(Self);
    lbcnpj.Name := 'lbcnpj';
    lbcnpj.Left := 24;
    lbcnpj.Top := 327;
    lbcnpj.Width := 24;
    lbcnpj.Height := 13;
    lbcnpj.Caption := 'cnpj:';
    lbcnpj.HeightPercent := 100.000000000000000000;
    lbcnpj.WidthPercent := 100.000000000000000000;
    lbendereco.SetParentComponent(Self);
    lbendereco.Name := 'lbendereco';
    lbendereco.Left := 24;
    lbendereco.Top := 354;
    lbendereco.Width := 49;
    lbendereco.Height := 13;
    lbendereco.Caption := 'endereco:';
    lbendereco.HeightPercent := 100.000000000000000000;
    lbendereco.WidthPercent := 100.000000000000000000;
    lbnumero.SetParentComponent(Self);
    lbnumero.Name := 'lbnumero';
    lbnumero.Left := 24;
    lbnumero.Top := 381;
    lbnumero.Width := 40;
    lbnumero.Height := 13;
    lbnumero.Caption := 'numero:';
    lbnumero.HeightPercent := 100.000000000000000000;
    lbnumero.WidthPercent := 100.000000000000000000;
    lbbairro.SetParentComponent(Self);
    lbbairro.Name := 'lbbairro';
    lbbairro.Left := 24;
    lbbairro.Top := 408;
    lbbairro.Width := 32;
    lbbairro.Height := 13;
    lbbairro.Caption := 'bairro:';
    lbbairro.HeightPercent := 100.000000000000000000;
    lbbairro.WidthPercent := 100.000000000000000000;
    lbcep.SetParentComponent(Self);
    lbcep.Name := 'lbcep';
    lbcep.Left := 24;
    lbcep.Top := 435;
    lbcep.Width := 21;
    lbcep.Height := 13;
    lbcep.Caption := 'cep:';
    lbcep.HeightPercent := 100.000000000000000000;
    lbcep.WidthPercent := 100.000000000000000000;
    lbcidade_id.SetParentComponent(Self);
    lbcidade_id.Name := 'lbcidade_id';
    lbcidade_id.Left := 24;
    lbcidade_id.Top := 462;
    lbcidade_id.Width := 49;
    lbcidade_id.Height := 13;
    lbcidade_id.Caption := 'cidade_id:';
    lbcidade_id.HeightPercent := 100.000000000000000000;
    lbcidade_id.WidthPercent := 100.000000000000000000;
    lbtaxa_administracao.SetParentComponent(Self);
    lbtaxa_administracao.Name := 'lbtaxa_administracao';
    lbtaxa_administracao.Left := 24;
    lbtaxa_administracao.Top := 489;
    lbtaxa_administracao.Width := 98;
    lbtaxa_administracao.Height := 13;
    lbtaxa_administracao.Caption := 'taxa_administracao:';
    lbtaxa_administracao.HeightPercent := 100.000000000000000000;
    lbtaxa_administracao.WidthPercent := 100.000000000000000000;
    lbsigla.SetParentComponent(Self);
    lbsigla.Name := 'lbsigla';
    lbsigla.Left := 24;
    lbsigla.Top := 516;
    lbsigla.Width := 25;
    lbsigla.Height := 13;
    lbsigla.Caption := 'sigla:';
    lbsigla.HeightPercent := 100.000000000000000000;
    lbsigla.WidthPercent := 100.000000000000000000;
    lbcodigo_instituicao.SetParentComponent(Self);
    lbcodigo_instituicao.Name := 'lbcodigo_instituicao';
    lbcodigo_instituicao.Left := 24;
    lbcodigo_instituicao.Top := 543;
    lbcodigo_instituicao.Width := 89;
    lbcodigo_instituicao.Height := 13;
    lbcodigo_instituicao.Caption := 'codigo_instituicao:';
    lbcodigo_instituicao.HeightPercent := 100.000000000000000000;
    lbcodigo_instituicao.WidthPercent := 100.000000000000000000;
    lbenviar_pdv.SetParentComponent(Self);
    lbenviar_pdv.Name := 'lbenviar_pdv';
    lbenviar_pdv.Left := 24;
    lbenviar_pdv.Top := 570;
    lbenviar_pdv.Width := 58;
    lbenviar_pdv.Height := 13;
    lbenviar_pdv.Caption := 'enviar_pdv:';
    lbenviar_pdv.HeightPercent := 100.000000000000000000;
    lbenviar_pdv.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 597;
    lbcodigo_interno.Width := 75;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 624;
    lbexcluido.Width := 43;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 651;
    lbinclusao.Width := 42;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 678;
    lbalteracao.Width := 49;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 705;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.TabOrder := 0;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.HeightPercent := 100.000000000000000000;
    lbMessage.WidthPercent := 100.000000000000000000;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.HeightPercent := 100.000000000000000000;
    btCloseMessage.WidthPercent := 100.000000000000000000;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 745;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 745;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 745;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.HeightPercent := 100.000000000000000000;
    btDelete.TabOrder := 5;
    btDelete.WidthPercent := 100.000000000000000000;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.HeightPercent := 100.000000000000000000;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.WidthPercent := 100.000000000000000000;
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.HeightPercent := 100.000000000000000000;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.WidthPercent := 100.000000000000000000;
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 270;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.TabOrder := 9;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    edconta_id.SetParentComponent(Self);
    edconta_id.Name := 'edconta_id';
    edconta_id.Left := 221;
    edconta_id.Top := 297;
    edconta_id.Width := 200;
    edconta_id.Height := 21;
    edconta_id.HeightPercent := 100.000000000000000000;
    edconta_id.TabOrder := 10;
    edconta_id.Text := 'edconta_id';
    edconta_id.WidthPercent := 100.000000000000000000;
    edconta_id.DataField := 'conta_id';
    edconta_id.DataSource := DataSource;
    edcnpj.SetParentComponent(Self);
    edcnpj.Name := 'edcnpj';
    edcnpj.Left := 221;
    edcnpj.Top := 324;
    edcnpj.Width := 200;
    edcnpj.Height := 21;
    edcnpj.HeightPercent := 100.000000000000000000;
    edcnpj.TabOrder := 11;
    edcnpj.Text := 'edcnpj';
    edcnpj.WidthPercent := 100.000000000000000000;
    edcnpj.DataField := 'cnpj';
    edcnpj.DataSource := DataSource;
    edendereco.SetParentComponent(Self);
    edendereco.Name := 'edendereco';
    edendereco.Left := 221;
    edendereco.Top := 351;
    edendereco.Width := 200;
    edendereco.Height := 21;
    edendereco.HeightPercent := 100.000000000000000000;
    edendereco.TabOrder := 12;
    edendereco.Text := 'edendereco';
    edendereco.WidthPercent := 100.000000000000000000;
    edendereco.DataField := 'endereco';
    edendereco.DataSource := DataSource;
    ednumero.SetParentComponent(Self);
    ednumero.Name := 'ednumero';
    ednumero.Left := 221;
    ednumero.Top := 378;
    ednumero.Width := 200;
    ednumero.Height := 21;
    ednumero.HeightPercent := 100.000000000000000000;
    ednumero.TabOrder := 13;
    ednumero.Text := 'ednumero';
    ednumero.WidthPercent := 100.000000000000000000;
    ednumero.DataField := 'numero';
    ednumero.DataSource := DataSource;
    edbairro.SetParentComponent(Self);
    edbairro.Name := 'edbairro';
    edbairro.Left := 221;
    edbairro.Top := 405;
    edbairro.Width := 200;
    edbairro.Height := 21;
    edbairro.HeightPercent := 100.000000000000000000;
    edbairro.TabOrder := 14;
    edbairro.Text := 'edbairro';
    edbairro.WidthPercent := 100.000000000000000000;
    edbairro.DataField := 'bairro';
    edbairro.DataSource := DataSource;
    edcep.SetParentComponent(Self);
    edcep.Name := 'edcep';
    edcep.Left := 221;
    edcep.Top := 432;
    edcep.Width := 200;
    edcep.Height := 21;
    edcep.HeightPercent := 100.000000000000000000;
    edcep.TabOrder := 15;
    edcep.Text := 'edcep';
    edcep.WidthPercent := 100.000000000000000000;
    edcep.DataField := 'cep';
    edcep.DataSource := DataSource;
    edcidade_id.SetParentComponent(Self);
    edcidade_id.Name := 'edcidade_id';
    edcidade_id.Left := 221;
    edcidade_id.Top := 459;
    edcidade_id.Width := 200;
    edcidade_id.Height := 21;
    edcidade_id.HeightPercent := 100.000000000000000000;
    edcidade_id.TabOrder := 16;
    edcidade_id.Text := 'edcidade_id';
    edcidade_id.WidthPercent := 100.000000000000000000;
    edcidade_id.DataField := 'cidade_id';
    edcidade_id.DataSource := DataSource;
    edtaxa_administracao.SetParentComponent(Self);
    edtaxa_administracao.Name := 'edtaxa_administracao';
    edtaxa_administracao.Left := 221;
    edtaxa_administracao.Top := 486;
    edtaxa_administracao.Width := 200;
    edtaxa_administracao.Height := 21;
    edtaxa_administracao.HeightPercent := 100.000000000000000000;
    edtaxa_administracao.TabOrder := 17;
    edtaxa_administracao.Text := 'edtaxa_administracao';
    edtaxa_administracao.WidthPercent := 100.000000000000000000;
    edtaxa_administracao.DataField := 'taxa_administracao';
    edtaxa_administracao.DataSource := DataSource;
    edsigla.SetParentComponent(Self);
    edsigla.Name := 'edsigla';
    edsigla.Left := 221;
    edsigla.Top := 513;
    edsigla.Width := 200;
    edsigla.Height := 21;
    edsigla.HeightPercent := 100.000000000000000000;
    edsigla.TabOrder := 18;
    edsigla.Text := 'edsigla';
    edsigla.WidthPercent := 100.000000000000000000;
    edsigla.DataField := 'sigla';
    edsigla.DataSource := DataSource;
    edcodigo_instituicao.SetParentComponent(Self);
    edcodigo_instituicao.Name := 'edcodigo_instituicao';
    edcodigo_instituicao.Left := 221;
    edcodigo_instituicao.Top := 540;
    edcodigo_instituicao.Width := 200;
    edcodigo_instituicao.Height := 21;
    edcodigo_instituicao.HeightPercent := 100.000000000000000000;
    edcodigo_instituicao.TabOrder := 19;
    edcodigo_instituicao.Text := 'edcodigo_instituicao';
    edcodigo_instituicao.WidthPercent := 100.000000000000000000;
    edcodigo_instituicao.DataField := 'codigo_instituicao';
    edcodigo_instituicao.DataSource := DataSource;
    edenviar_pdv.SetParentComponent(Self);
    edenviar_pdv.Name := 'edenviar_pdv';
    edenviar_pdv.Left := 221;
    edenviar_pdv.Top := 567;
    edenviar_pdv.Width := 200;
    edenviar_pdv.Height := 21;
    edenviar_pdv.HeightPercent := 100.000000000000000000;
    edenviar_pdv.TabOrder := 20;
    edenviar_pdv.Text := 'edenviar_pdv';
    edenviar_pdv.WidthPercent := 100.000000000000000000;
    edenviar_pdv.DataField := 'enviar_pdv';
    edenviar_pdv.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 594;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 21;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 621;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.HeightPercent := 100.000000000000000000;
    edexcluido.TabOrder := 22;
    edexcluido.Text := 'edexcluido';
    edexcluido.WidthPercent := 100.000000000000000000;
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 648;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 23;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 675;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 24;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 702;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 25;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Operadoras_CartaoDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Operadoras_CartaoDataset.SetParentComponent(Self);
    Operadoras_CartaoDataset.Name := 'Operadoras_CartaoDataset';
    Operadoras_CartaoDataset.AfterApplyUpdates := Operadoras_CartaoDatasetAfterApplyUpdates;
    Operadoras_CartaoDataset.EntitySetName := 'Operadoras_Cartao';
    Operadoras_CartaoDataset.Connection := DMConnection.ApiConnection;
    Operadoras_CartaoDataset.Left := 176;
    Operadoras_CartaoDataset.Top := 8;
    Operadoras_CartaoDatasetid.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetid.Name := 'Operadoras_CartaoDatasetid';
    Operadoras_CartaoDatasetid.FieldName := 'id';
    Operadoras_CartaoDatasetid.Required := True;
    Operadoras_CartaoDatasetaliado_id.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetaliado_id.Name := 'Operadoras_CartaoDatasetaliado_id';
    Operadoras_CartaoDatasetaliado_id.FieldName := 'aliado_id';
    Operadoras_CartaoDatasetaliado_id.Required := True;
    Operadoras_CartaoDatasetdata_base_id.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetdata_base_id.Name := 'Operadoras_CartaoDatasetdata_base_id';
    Operadoras_CartaoDatasetdata_base_id.FieldName := 'data_base_id';
    Operadoras_CartaoDatasetdata_base_id.Required := True;
    Operadoras_CartaoDatasetnome.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetnome.Name := 'Operadoras_CartaoDatasetnome';
    Operadoras_CartaoDatasetnome.FieldName := 'nome';
    Operadoras_CartaoDatasetnome.Required := True;
    Operadoras_CartaoDatasetnome.Size := 255;
    Operadoras_CartaoDatasetconta_id.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetconta_id.Name := 'Operadoras_CartaoDatasetconta_id';
    Operadoras_CartaoDatasetconta_id.FieldName := 'conta_id';
    Operadoras_CartaoDatasetcnpj.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetcnpj.Name := 'Operadoras_CartaoDatasetcnpj';
    Operadoras_CartaoDatasetcnpj.FieldName := 'cnpj';
    Operadoras_CartaoDatasetcnpj.Size := 255;
    Operadoras_CartaoDatasetendereco.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetendereco.Name := 'Operadoras_CartaoDatasetendereco';
    Operadoras_CartaoDatasetendereco.FieldName := 'endereco';
    Operadoras_CartaoDatasetendereco.Size := 255;
    Operadoras_CartaoDatasetnumero.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetnumero.Name := 'Operadoras_CartaoDatasetnumero';
    Operadoras_CartaoDatasetnumero.FieldName := 'numero';
    Operadoras_CartaoDatasetbairro.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetbairro.Name := 'Operadoras_CartaoDatasetbairro';
    Operadoras_CartaoDatasetbairro.FieldName := 'bairro';
    Operadoras_CartaoDatasetbairro.Size := 255;
    Operadoras_CartaoDatasetcep.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetcep.Name := 'Operadoras_CartaoDatasetcep';
    Operadoras_CartaoDatasetcep.FieldName := 'cep';
    Operadoras_CartaoDatasetcep.Size := 255;
    Operadoras_CartaoDatasetcidade_id.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetcidade_id.Name := 'Operadoras_CartaoDatasetcidade_id';
    Operadoras_CartaoDatasetcidade_id.FieldName := 'cidade_id';
    Operadoras_CartaoDatasettaxa_administracao.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasettaxa_administracao.Name := 'Operadoras_CartaoDatasettaxa_administracao';
    Operadoras_CartaoDatasettaxa_administracao.FieldName := 'taxa_administracao';
    Operadoras_CartaoDatasetsigla.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetsigla.Name := 'Operadoras_CartaoDatasetsigla';
    Operadoras_CartaoDatasetsigla.FieldName := 'sigla';
    Operadoras_CartaoDatasetsigla.Size := 255;
    Operadoras_CartaoDatasetcodigo_instituicao.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetcodigo_instituicao.Name := 'Operadoras_CartaoDatasetcodigo_instituicao';
    Operadoras_CartaoDatasetcodigo_instituicao.FieldName := 'codigo_instituicao';
    Operadoras_CartaoDatasetcodigo_instituicao.Size := 255;
    Operadoras_CartaoDatasetenviar_pdv.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetenviar_pdv.Name := 'Operadoras_CartaoDatasetenviar_pdv';
    Operadoras_CartaoDatasetenviar_pdv.FieldName := 'enviar_pdv';
    Operadoras_CartaoDatasetenviar_pdv.Required := True;
    Operadoras_CartaoDatasetcodigo_interno.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetcodigo_interno.Name := 'Operadoras_CartaoDatasetcodigo_interno';
    Operadoras_CartaoDatasetcodigo_interno.FieldName := 'codigo_interno';
    Operadoras_CartaoDatasetcodigo_interno.Required := True;
    Operadoras_CartaoDatasetexcluido.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetexcluido.Name := 'Operadoras_CartaoDatasetexcluido';
    Operadoras_CartaoDatasetexcluido.FieldName := 'excluido';
    Operadoras_CartaoDatasetinclusao.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetinclusao.Name := 'Operadoras_CartaoDatasetinclusao';
    Operadoras_CartaoDatasetinclusao.FieldName := 'inclusao';
    Operadoras_CartaoDatasetalteracao.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetalteracao.Name := 'Operadoras_CartaoDatasetalteracao';
    Operadoras_CartaoDatasetalteracao.FieldName := 'alteracao';
    Operadoras_CartaoDatasetexclusao.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetexclusao.Name := 'Operadoras_CartaoDatasetexclusao';
    Operadoras_CartaoDatasetexclusao.FieldName := 'exclusao';
    XDataClientOperadoras_CartaoGet.SetParentComponent(Self);
    XDataClientOperadoras_CartaoGet.Name := 'XDataClientOperadoras_CartaoGet';
    XDataClientOperadoras_CartaoGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientOperadoras_CartaoGet, Self, 'OnLoad', 'XDataClientOperadoras_CartaoGetLoad');
    XDataClientOperadoras_CartaoGet.Left := 64;
    XDataClientOperadoras_CartaoGet.Top := 8;
    XDataClientOperadoras_CartaoDelete.SetParentComponent(Self);
    XDataClientOperadoras_CartaoDelete.Name := 'XDataClientOperadoras_CartaoDelete';
    XDataClientOperadoras_CartaoDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientOperadoras_CartaoDelete, Self, 'OnLoad', 'XDataClientOperadoras_CartaoDeleteLoad');
    SetEvent(XDataClientOperadoras_CartaoDelete, Self, 'OnError', 'XDataClientOperadoras_CartaoDeleteError');
    XDataClientOperadoras_CartaoDelete.Left := 64;
    XDataClientOperadoras_CartaoDelete.Top := 56;
  finally
    lbid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbconta_id.AfterLoadDFMValues;
    lbcnpj.AfterLoadDFMValues;
    lbendereco.AfterLoadDFMValues;
    lbnumero.AfterLoadDFMValues;
    lbbairro.AfterLoadDFMValues;
    lbcep.AfterLoadDFMValues;
    lbcidade_id.AfterLoadDFMValues;
    lbtaxa_administracao.AfterLoadDFMValues;
    lbsigla.AfterLoadDFMValues;
    lbcodigo_instituicao.AfterLoadDFMValues;
    lbenviar_pdv.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    edconta_id.AfterLoadDFMValues;
    edcnpj.AfterLoadDFMValues;
    edendereco.AfterLoadDFMValues;
    ednumero.AfterLoadDFMValues;
    edbairro.AfterLoadDFMValues;
    edcep.AfterLoadDFMValues;
    edcidade_id.AfterLoadDFMValues;
    edtaxa_administracao.AfterLoadDFMValues;
    edsigla.AfterLoadDFMValues;
    edcodigo_instituicao.AfterLoadDFMValues;
    edenviar_pdv.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Operadoras_CartaoDataset.AfterLoadDFMValues;
    Operadoras_CartaoDatasetid.AfterLoadDFMValues;
    Operadoras_CartaoDatasetaliado_id.AfterLoadDFMValues;
    Operadoras_CartaoDatasetdata_base_id.AfterLoadDFMValues;
    Operadoras_CartaoDatasetnome.AfterLoadDFMValues;
    Operadoras_CartaoDatasetconta_id.AfterLoadDFMValues;
    Operadoras_CartaoDatasetcnpj.AfterLoadDFMValues;
    Operadoras_CartaoDatasetendereco.AfterLoadDFMValues;
    Operadoras_CartaoDatasetnumero.AfterLoadDFMValues;
    Operadoras_CartaoDatasetbairro.AfterLoadDFMValues;
    Operadoras_CartaoDatasetcep.AfterLoadDFMValues;
    Operadoras_CartaoDatasetcidade_id.AfterLoadDFMValues;
    Operadoras_CartaoDatasettaxa_administracao.AfterLoadDFMValues;
    Operadoras_CartaoDatasetsigla.AfterLoadDFMValues;
    Operadoras_CartaoDatasetcodigo_instituicao.AfterLoadDFMValues;
    Operadoras_CartaoDatasetenviar_pdv.AfterLoadDFMValues;
    Operadoras_CartaoDatasetcodigo_interno.AfterLoadDFMValues;
    Operadoras_CartaoDatasetexcluido.AfterLoadDFMValues;
    Operadoras_CartaoDatasetinclusao.AfterLoadDFMValues;
    Operadoras_CartaoDatasetalteracao.AfterLoadDFMValues;
    Operadoras_CartaoDatasetexclusao.AfterLoadDFMValues;
    XDataClientOperadoras_CartaoGet.AfterLoadDFMValues;
    XDataClientOperadoras_CartaoDelete.AfterLoadDFMValues;
  end;
end;

end.
